import { render, staticRenderFns } from "./PhysicalPersonEdit.vue?vue&type=template&id=656aab21&scoped=true"
import script from "./PhysicalPersonEdit.vue?vue&type=script&lang=js"
export * from "./PhysicalPersonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656aab21",
  null
  
)

export default component.exports